import { motion } from 'motion/react';
import { ReactElement } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

import { color } from '@creditornot/cb-ingredients/design-tokens';

const Bar = styled.div`
  position: fixed;
  z-index: 20;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
`;

const Indicator = styled(motion.div)`
  position: absolute;
  width: 10%;
  height: 100%;
  background: ${color.bgFillBrand};
`;

export const LoadingBar = (): ReactElement => {
  return createPortal(
    <Bar>
      <Indicator
        animate={{
          width: ['0%', '100%', '0%', '100%'],
          left: ['0%', '0%', '100%', '100%'],
        }}
        transition={{ repeat: Infinity, duration: 4, delay: 0.4 }}
      />
    </Bar>,
    document.body,
  );
};
